import axios from "axios";
import {useState} from "react";

const fetchRelatedBills = async (filters) => {

    const limit = 150;
    let allBills = [];
    let currentPage = 0;
    let totalPages = 1;
    let includeCounts = false

    // Bill Type Ids
    const billTypeIdList = {
        'HB':1,
        'HJ':3,
        'HR':2,
        'SB':4,
        'SJ':6,
        'SR':5,
    }

    // All Relevant Status Ids
    const relevantAllList = [
        54, 55, 64, 65, 66, 67, 80, 81, 136, 137, 158, 286, 287, 291, 292, 293, 294, 311, 312, 366, 367, 388
    ]

    // Scheduled/Hearing Status Ids - [6x] is Senate and [29x] is House
    const hearingAllList= [64, 65, 66, 67, 291, 292, 293, 294]
    const hearingScheduledList= [64, 65, 291, 292]
    const hearingCancelledList= [66, 67, 293, 294]

    // Referred Status Ids
    const referredAllList= [54, 55, 80, 81, 136, 137, 158, 286, 287, 311, 312, 366, 367, 388]
    const referredHouseList= [286, 287, 311, 312, 366, 367, 388]
    const referredSenateList= [54, 55, 80, 81, 136, 137, 158]

    const committeeIds = filters.committeeIds || []
    const legislators = filters.legislators || {legs: [], roles: []}
    const billType = filters.billType || []
    const billStatus = filters.billStatus !== undefined ?
        filters.billStatus ? hearingAllList : relevantAllList : []
    const sessionIds = filters.sessionIds || []

    try {
        while (currentPage < totalPages) {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search?limit=${limit}&offset=${currentPage}&includeCounts=${includeCounts}`,
                {
                    standingCommitteeIds: committeeIds,
                    optionalFields: {
                        sponsorIds: legislators.roles.includes("Sponsor") ?
                            legislators.legs : [],
                        requesterLegislatorIds: legislators.roles.includes("Requester") ?
                            legislators.legs : []
                    },
                    billTypeIds: billType,
                    billStatusCodeIds: billStatus,
                    sessionIds: sessionIds
                }
            );
            const billInCurrentPage = response.data;
            let currentPageBills = billInCurrentPage.content || [];

            if (committeeIds?.length === 1) {
                const [currentCommitteeId] = committeeIds;
                currentPageBills = currentPageBills.filter((bill) => {
                    const statuses = bill?.draft?.billStatuses;
                    for (let i = statuses.length - 1; i >= 0; i--) {
                        if (statuses[i].standingCommitteeId !== null) {
                            return statuses[i].standingCommitteeId = currentCommitteeId;
                        }
                    }
                    return true;
                });
            }
            allBills = allBills.concat(currentPageBills);

            totalPages = billInCurrentPage.totalPages;
            currentPage++;
        }
    } catch (error) {
        console.error("Error fetching related bills:", error);
    }
    return allBills;
};

export default fetchRelatedBills;